// extracted by mini-css-extract-plugin
export default {"homeHeader":"Pages_homeHeader__09gHz","homeBackground":"Pages_homeBackground__HvU2z"};